/* ──────────────────────────────────────────────────────────────
   COULEUR — shared behaviors
   Heading Text Fill: characters in [data-fill] elements resolve
   faint → solid (char by char) when their .text-fill container
   enters the viewport. Two-way (re-fills on re-entry). Respects
   prefers-reduced-motion.
   ────────────────────────────────────────────────────────────── */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Split a single element's text into per-char <span class="rw">, preserving <br>.
  function buildChars(el, start) {
    var idx = start;
    var nodes = Array.prototype.slice.call(el.childNodes);
    el.innerHTML = '';
    nodes.forEach(function (n) {
      if (n.nodeType === 3) {                      // text node
        var t = n.nodeValue;
        for (var i = 0; i < t.length; i++) {
          var s = document.createElement('span');
          s.className = 'rw';
          s.textContent = t[i];
          s.style.setProperty('--i', idx++);       // continuous index across the block
          el.appendChild(s);
        }
      } else if (n.nodeName === 'BR') {
        el.appendChild(document.createElement('br'));
      } else {
        el.appendChild(n);                          // keep other nodes as-is
      }
    });
    return idx;
  }

  function init() {
    document.querySelectorAll('.text-fill').forEach(function (box) {
      var idx = 0;
      box.querySelectorAll('[data-fill]').forEach(function (el) { idx = buildChars(el, idx); });
      if (!box.querySelector('.rw')) return;
      if (reduce) { box.classList.add('is-filled'); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { e.target.classList.toggle('is-filled', e.isIntersecting); });
      }, { threshold: 0.25 });
      io.observe(box);
    });

    // ── FOCUS PULL HERO — bg racks out of focus while text racks in (swap) ──
    document.querySelectorAll('[data-focus-hero]').forEach(function (el) {
      if (reduce) { el.classList.add('is-focused'); return; }
      var pull = function () {
        // show the sharp frame briefly, then rack focus (setTimeout = fires even when hidden)
        setTimeout(function () { el.classList.add('is-focused'); }, 340);
      };
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) { pull(); return; } // already in view (hero on load)
      var io2 = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { pull(); obs.unobserve(e.target); }
        });
      }, { threshold: 0.35 });
      io2.observe(el);
    });

    // ── CARDS REVEAL — グリッドの列staggerリビール ──
    // 0618 info.html:194-203 / plp.html:359-367 と同契約:
    //   セル取得は grid.children（クラス非依存）／observe 対象は grid 自身／付与クラスは is-in（双方向トグル）。
    // couleur.css:1004 の `.cards-reveal.is-in > *` が 220ms 列カスケードの唯一の解除セレクタなので変更禁止。
    document.querySelectorAll('.cards-reveal').forEach(function (grid) {
      var cells = grid.children;
      var cols = 4;
      try { cols = getComputedStyle(grid).gridTemplateColumns.split(' ').filter(Boolean).length || 4; } catch (e) {}
      Array.prototype.forEach.call(cells, function (c, i) { c.style.setProperty('--i', i % cols); });
      if (reduce) { grid.classList.add('is-in'); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { e.target.classList.toggle('is-in', e.isIntersecting); }); // 双方向: 上スクロールで再演出
      }, { rootMargin: '-10% 0px -10% 0px', threshold: 0 });
      io.observe(grid);
    });

    // ── SHARED SCROLL REVEAL — 単独の data-scroll-reveal / scroll-reveal / glass-reveal を可視化 ──
    // （.cards-reveal グリッド内は上の専用ハンドラに任せ、ここでは除外して二重制御を避ける）
    // .pdp 配下は pdp セクションのインライン runEntrance（load 起点: curtain +260ms → items 720+data-delay）が
    // 唯一の発火源。共有 IO が DCL 基準で先に確定すると 0618 の入場順序が反転するため除外する（監査 group 10）。
    var revealEls = Array.prototype.filter.call(
      document.querySelectorAll('[data-scroll-reveal], .scroll-reveal, .glass-reveal'),
      function (el) { return !el.closest('.cards-reveal') && !el.closest('.pdp'); }
    );
    if (revealEls.length) {
      if (reduce) {
        revealEls.forEach(function (el) { el.classList.add('is-visible'); });
      } else {
        var ioReveal = new IntersectionObserver(function (entries, obs) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            var d = parseInt(e.target.getAttribute('data-delay'), 10) || 0;
            var t = e.target;
            setTimeout(function () { t.classList.add('is-visible'); }, d);
            obs.unobserve(t);
          });
        }, { threshold: 0.12 });
        revealEls.forEach(function (el) { ioReveal.observe(el); });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ─── CURRENCY DROPDOWN ─── */
(function () {
  'use strict';

  var RATES   = { jpy: 1, usd: 1 / 155, eur: 1 / 165, cny: 1 / 21 };
  var SYMBOLS = { jpy: '¥', usd: '$', eur: '€', cny: 'CN¥' };

  function initPrices() {
    document.querySelectorAll('.pprice, .pdp-price, .pdp-sticky-price, .cart-price, .summary-total-val').forEach(function (el) {
      if (!el.dataset.jpy) {
        var raw = el.textContent.replace(/[^\d]/g, '');
        if (raw) el.dataset.jpy = raw;
      }
    });
  }

  function applyRate(currency) {
    var rate = RATES[currency];
    var sym  = SYMBOLS[currency];
    document.querySelectorAll('.pprice, .pdp-price, .pdp-sticky-price, .cart-price, .summary-total-val').forEach(function (el) {
      var jpy = parseInt(el.dataset.jpy, 10);
      if (!jpy) return;
      var formatted = Math.round(jpy * rate).toLocaleString('en-US');
      var suffix = (currency === 'jpy' && el.classList.contains('pdp-price')) ? '<span class="tax">' + ((window.CouleurI18n && window.CouleurI18n.price_tax_included) || '税込') + '</span>' : '';
      el.innerHTML = sym + formatted + suffix;
    });
    // Update active option
    document.querySelectorAll('.currency-opt').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.dataset.currency === currency);
    });
    // Update trigger button label
    document.querySelectorAll('.currency-dd-btn').forEach(function (btn) {
      btn.firstChild.textContent = sym;
    });
    try { localStorage.setItem('couleur-currency', currency); } catch(e) {}
  }

  function closeAll() {
    document.querySelectorAll('.currency-dd.is-open').forEach(function (dd) {
      dd.classList.remove('is-open');
      dd.querySelector('.currency-dd-menu').hidden = true;
      dd.querySelector('.currency-dd-btn').setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    // 実 Markets 結線時（ヘッダーが localization form を出力）は擬似レートを停止し実切替に委ねる
    var realCurrencyForm = !!document.querySelector('.currency-form');
    if (!realCurrencyForm) {
      initPrices();
      // Restore saved preference
      var saved = 'jpy';
      try { saved = localStorage.getItem('couleur-currency') || 'jpy'; } catch(e) {}
      if (saved !== 'jpy') applyRate(saved);
    }

    // Toggle dropdown
    document.addEventListener('click', function (e) {
      var trigBtn = e.target.closest('.currency-dd-btn');
      var optBtn  = e.target.closest('.currency-opt');

      if (trigBtn) {
        e.stopPropagation();
        var dd   = trigBtn.closest('.currency-dd');
        var menu = dd.querySelector('.currency-dd-menu');
        var isOpen = dd.classList.contains('is-open');
        closeAll();
        if (!isOpen) {
          dd.classList.add('is-open');
          menu.hidden = false;
          trigBtn.setAttribute('aria-expanded', 'true');
        }
        return;
      }

      if (optBtn) {
        if (optBtn.dataset.country) {
          // 実 Markets: hidden country_code に反映し localization form を送信（実通貨切替）
          var form = optBtn.closest('.currency-form');
          var input = form && form.querySelector('input[name="country_code"]');
          if (input) { input.value = optBtn.dataset.country; form.submit(); }
        } else {
          applyRate(optBtn.dataset.currency);
        }
        closeAll();
        return;
      }

      // Click outside → close
      closeAll();
    });

    // CG7-4: 通貨ドロップダウンのキーボード操作（Escape で閉じ、上下矢印で option 移動）。既存 click 挙動は不変。
    document.addEventListener('keydown', function (e) {
      var dd = document.querySelector('.currency-dd.is-open');
      if (!dd) return;
      if (e.key === 'Escape') {
        closeAll();
        var t = dd.querySelector('.currency-dd-btn');
        if (t) t.focus();
        return;
      }
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        var list = Array.prototype.slice.call(dd.querySelectorAll('.currency-opt'));
        if (!list.length) return;
        e.preventDefault();
        var idx = list.indexOf(document.activeElement);
        idx = e.key === 'ArrowDown' ? (idx + 1) % list.length : (idx - 1 + list.length) % list.length;
        list[idx].focus();
      }
    });
  });
})();

/* ─── SEARCH OVERLAY ─── */
(function () {
  'use strict';
  document.addEventListener('DOMContentLoaded', function () {
    // Inject overlay HTML once
    // 0618 は結果ページを持たない静的モックだったが、テーマは /search(templates/search.json)を
    // 新設したので overlay を実フォームとして結線する。action は Liquid が使えないため
    // [data-search-trigger] の href(= routes.search_url) から読む。
    // .search-inner の flex/height:52px(couleur.css:237-243) は要素非依存なので見た目は不変。
    var trigger0 = document.querySelector('[data-search-trigger]');
    var searchAction = (trigger0 && trigger0.getAttribute('href')) || '/search';
    var overlay = document.createElement('div');
    overlay.id = 'search-overlay';
    overlay.setAttribute('hidden', '');
    overlay.setAttribute('role', 'search');
    overlay.innerHTML =
      '<form class="search-inner" action="' + searchAction + '" method="get">' +
        '<input class="search-input" type="search" name="q" placeholder="' + ((window.CouleurI18n && window.CouleurI18n.search_placeholder) || 'ブランド、商品名で検索…') + '" autocomplete="off" aria-label="' + ((window.CouleurI18n && window.CouleurI18n.search_label) || 'サイト内検索') + '">' +
        // implicit submission をフィールド数に依存させないための既定ボタン（hidden = display:none で flex に影響しない）
        '<button class="search-submit" type="submit" hidden aria-hidden="true" tabindex="-1">' + ((window.CouleurI18n && window.CouleurI18n.search_submit) || '検索') + '</button>' +
        '<button class="search-close" type="button" aria-label="' + ((window.CouleurI18n && window.CouleurI18n.search_close) || '検索を閉じる') + '">×</button>' +
      '</form>';
    document.body.appendChild(overlay);

    var input = overlay.querySelector('.search-input');
    var closeBtn = overlay.querySelector('.search-close');

    function openSearch() {
      overlay.removeAttribute('hidden');
      requestAnimationFrame(function () { overlay.classList.add('is-open'); });
      setTimeout(function () { input.focus(); }, 50);
    }

    function closeSearch() {
      overlay.classList.remove('is-open');
      setTimeout(function () { overlay.setAttribute('hidden', ''); input.value = ''; }, 220);
    }

    // Wire search triggers（統一決定 #E: textContent判定 → [data-search-trigger] 属性ベース。
    // 多言語化に強く、href は実 /search にしてJS無効時もフォールバック動作）
    document.querySelectorAll('[data-search-trigger]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        overlay.hasAttribute('hidden') ? openSearch() : closeSearch();
      });
    });

    closeBtn.addEventListener('click', closeSearch);

    // ESC to close
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeSearch();
    });

    // Click outside overlay to close
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeSearch();
    });
  });
})();

/* ─── LANGUAGE SWITCHER ─── */
(function () {
  'use strict';
  document.addEventListener('DOMContentLoaded', function () {
    var opts = document.querySelectorAll('.lang-opt');
    opts.forEach(function (opt) {
      opt.addEventListener('click', function (e) {
        // 実 Markets 結線時（.lang-form 内の submit ボタン）は既定の form 送信＝実言語切替に委ねる
        if (opt.closest('.lang-form')) return;
        e.preventDefault();
        opts.forEach(function (o) { o.classList.remove('is-active'); });
        opt.classList.add('is-active');
        // 将来の多言語実装: document.documentElement.lang = opt.dataset.lang;
      });
    });
    // CG7-4 / [F2]: .lang-opt は <a href> で Enter は既定 click 発火。Space のみ補完(二重発火回避)。
    // バーガーが後から生成するモバイル複製 .lang-opt(.nav-menu-lang)も拾うため document へ委譲
    // （初期DOMスナップショット非依存）。各 .lang-opt の click 同期は既存ハンドラに委ねる。
    document.addEventListener('keydown', function (e) {
      if (e.key !== ' ' && e.key !== 'Spacebar') return;
      var lo = e.target.closest && e.target.closest('.lang-opt');
      if (lo) { e.preventDefault(); lo.click(); }
    });
  });
})();

/* ─── HAMBURGER MENU (mobile) ─── */
(function () {
  'use strict';

  var nav = document.getElementById('nav');
  if (!nav) return;

  // ── 1. Create burger button and inject into nav-r ──
  var burger = document.createElement('button');
  burger.className = 'nav-burger';
  burger.setAttribute('aria-label', (window.CouleurI18n && window.CouleurI18n.menu) || 'メニュー');
  burger.setAttribute('aria-expanded', 'false');
  burger.innerHTML = '<span></span><span></span><span></span>';
  var navR = nav.querySelector('.nav-r');
  if (navR) navR.appendChild(burger);

  // ── 2. Build menu overlay from existing nav links ──
  var menu = document.createElement('div');
  menu.className = 'nav-menu';
  menu.id = 'navMenu';

  var inner = document.createElement('div');
  inner.className = 'nav-menu-inner';

  // Main links (nav-l)
  nav.querySelectorAll('.nav-l a').forEach(function (link) {
    var a = document.createElement('a');
    a.href = link.href;
    a.textContent = link.textContent;
    a.className = 'nav-menu-link';
    inner.appendChild(a);
  });

  // Separator
  inner.appendChild(Object.assign(document.createElement('div'), { className: 'nav-menu-sep' }));

  // Utility links (Search / Cart)
  nav.querySelectorAll('.nav-r > a').forEach(function (link) {
    var a = document.createElement('a');
    a.href = link.href;
    a.textContent = link.textContent;
    a.className = 'nav-menu-link nav-menu-link--sm';
    inner.appendChild(a);
  });

  // Language switcher
  var langOpts = nav.querySelectorAll('.lang-opt');
  if (langOpts.length) {
    inner.appendChild(Object.assign(document.createElement('div'), { className: 'nav-menu-sep' }));
    var langRow = document.createElement('div');
    langRow.className = 'nav-menu-lang';
    langOpts.forEach(function (opt, i) {
      var a = document.createElement('a');
      a.href = '#';
      a.className = 'lang-opt' + (opt.classList.contains('is-active') ? ' is-active' : '');
      a.dataset.lang = opt.dataset.lang;
      a.textContent = opt.textContent;
      langRow.appendChild(a);
      if (i < langOpts.length - 1) {
        langRow.appendChild(Object.assign(document.createElement('span'), { className: 'lang-sep', textContent: '·' }));
      }
    });
    inner.appendChild(langRow);
  }

  menu.appendChild(inner);
  document.body.appendChild(menu);

  // ── 3. Toggle ──
  function openMenu() {
    menu.classList.add('is-open');
    burger.classList.add('is-open');
    burger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    menu.classList.remove('is-open');
    burger.classList.remove('is-open');
    burger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  burger.addEventListener('click', function () {
    menu.classList.contains('is-open') ? closeMenu() : openMenu();
  });

  // CG7-4: Escape でメニューを閉じ、フォーカスを burger に戻す（既存 click 挙動は不変）
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && menu.classList.contains('is-open')) {
      closeMenu();
      burger.focus();
    }
  });

  // Close when a menu link is tapped
  menu.querySelectorAll('.nav-menu-link').forEach(function (link) {
    link.addEventListener('click', closeMenu);
  });

  // ── 4. Sync lang switch between nav and menu ──
  menu.querySelectorAll('.lang-opt').forEach(function (opt) {
    opt.addEventListener('click', function (e) {
      e.preventDefault();
      var lang = opt.dataset.lang;
      // 実 Markets 結線時: nav 側フォームの該当 locale submit ボタンを押して実言語切替
      var realBtn = document.querySelector('.lang-form .lang-opt[data-lang="' + lang + '"]');
      if (realBtn) { realBtn.click(); return; }
      document.querySelectorAll('.lang-opt').forEach(function (o) {
        o.classList.toggle('is-active', o.dataset.lang === lang);
      });
    });
  });
})();

/* ── Shopify Theme Editor: re-init shared behaviors on section (re)load（Plan1 Task6 / CG2-4） ── */
(function () {
  'use strict';
  if (!(window.Shopify && Shopify.designMode)) return;
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target || document;
    root.querySelectorAll('[data-focus-hero]').forEach(function (el) {
      el.classList.remove('is-focused');
      setTimeout(function () { el.classList.add('is-focused'); }, 340);
    });
    root.querySelectorAll('.glass-reveal').forEach(function (el) { el.classList.add('is-visible'); });
  });
})();

/* ── Inquiry プリフィル ────────────────────────────────────────────
   0618 contact.html:185-190 の契約どおり brand / item(product) / size を
   各フィールドへ入れるだけで、本文(#ContactForm-body)への注入も focus() も
   行わない（focus すると入場の text-fill / scroll-reveal が飛ぶ）。
   実装は sections/couleur-contact.liquid のインライン script にある。 */

/* ── トースト + カート追加の非同期化（0618 pdp.html:412-426 が正典） ─────────────
   0618 は「クリックしたらトーストを出す」だけの静的モックだった（カートが無いので当然）。
   実ストアでそのまま真似ると、フォーム送信で /cart へ全画面遷移するためトーストは一瞬で消え、
   商品ページから引き剥がされる。0618 が表現していた「ページに留まったまま追加された合図」を
   実現するには、追加を非同期にしてページ遷移を止める必要がある。

   段階的強化にしてある。fetch が無い／通信が失敗した環境では preventDefault を取り消して
   通常のフォーム送信に戻すので、**JSが死んでも購入導線は壊れない**。 */
(function () {
  'use strict';

  var TOAST_MS = 2600;   // 0618 pdp.html:420 と同値
  var FADE_MS  = 320;    // 同上

  function showToast(msg, isError) {
    var t = document.createElement('div');
    t.className = 'toast' + (isError ? ' toast--error' : '');
    t.setAttribute('role', 'status');
    t.setAttribute('aria-live', 'polite');
    t.textContent = msg;
    document.body.appendChild(t);
    // 追加直後に is-visible を付けても遷移が走らない（同一フレーム）。次フレームまで待つ。
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { t.classList.add('is-visible'); });
    });
    setTimeout(function () {
      t.classList.remove('is-visible');
      setTimeout(function () { if (t.parentNode) t.remove(); }, FADE_MS);
    }, TOAST_MS);
  }
  window.couleurToast = showToast;   // 他のスクリプトからも使えるように

  function setCartCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; });
    // モバイルメニューは couleur.js が nav-r から複製して作るため、複製側も同じ目印を持つ。
  }

  function initAjaxCart() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      if (form.dataset.ajaxCart) return;      // 二重束縛の防止（section:load で再実行されるため）
      form.dataset.ajaxCart = '1';

      form.addEventListener('submit', function (e) {
        if (!window.fetch || !window.FormData) return;   // 非対応環境は通常送信に委ねる
        e.preventDefault();

        // 送信ボタンは form 属性で外側にも置かれている（固定CTA）。両方を止める。
        var btns = [].slice.call(form.querySelectorAll('[name="add"]'))
          .concat(form.id ? [].slice.call(document.querySelectorAll('[form="' + form.id + '"][name="add"]')) : []);
        if (btns.some(function (b) { return b.disabled; })) return;   // 連打による二重追加を防ぐ
        btns.forEach(function (b) { b.disabled = true; });
        var release = function () { btns.forEach(function (b) { b.disabled = false; }); };

        fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js', {
          method: 'POST',
          body: new FormData(form),
          headers: { 'Accept': 'application/json' },
          credentials: 'same-origin'
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            if (!res.ok) {
              // Shopify は在庫切れ等の理由を description に入れて返す。握り潰さず本人の言葉で見せる。
              showToast(res.body.description || res.body.message || (window.CouleurI18n && window.CouleurI18n.cart_add_error) || 'カートに追加できませんでした', true);
              release();
              return;
            }
            showToast((window.CouleurI18n && window.CouleurI18n.cart_added) || 'カートに追加しました — Added to cart');
            return fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart.js', { credentials: 'same-origin' })
              .then(function (r) { return r.json(); })
              .then(function (c) { setCartCount(c.item_count); })
              .catch(function () { /* 件数の更新に失敗してもトーストは出ている。導線は生きている */ })
              .then(release);
          })
          .catch(function () {
            // 通信そのものが失敗した場合は、非同期化を諦めて通常送信へ戻す。
            // form.submit() は submit イベントを発火しないので、この listener には戻ってこない。
            release();
            form.submit();
          });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAjaxCart);
  } else {
    initAjaxCart();
  }
  // テーマエディタでセクションを差し替えた時も配線し直す
  document.addEventListener('shopify:section:load', initAjaxCart);
})();
